export default {
    /** Links between the three newsletter screens. */
    nav: {
        campaigns: 'Campaigns',
        subscribers: 'Subscribers',
        settings: 'Settings',
    },
    campaignStatus: {
        scheduled: 'Scheduled',
        sending: 'Sending',
        sent: 'Sent',
        failed: 'Failed',
    },
    subscriberStatus: {
        confirmed: 'Confirmed',
        pending: 'Pending',
        unsubscribed: 'Unsubscribed',
    },
    shared: {
        anyStatus: 'Any status',
        subject: 'Subject',
        settingsSaved: 'Settings saved',
    },
    campaigns: {
        title: 'Newsletter campaigns',
        new: 'New campaign',
        empty: 'No campaigns yet. Create one to email your subscribers.',
        progress: 'Progress',
        scheduledOrSent: 'Scheduled / sent',
        sentCount: '{n} sent',
    },
    campaign: {
        message: 'Message',
        body: 'Body',
        plainText: 'Plain-text version (optional)',
        plainTextHint: 'Leave blank to auto-derive from the HTML. A text part improves deliverability.',
        audience: 'Audience',
        audienceCount: '{number} confirmed subscriber | {number} confirmed subscribers',
        sentSoFar: 'Sent so far: {sent} / {total}',
        skipped: 'Skipped',
        testTitle: 'Send a test',
        testRecipient: 'Test recipient',
        testPlaceholder: "you{'@'}example.com",
        sendTest: 'Send test',
        sendTitle: 'Send',
        sendNow: 'Send now',
        scheduleLater: 'Or schedule for later',
        schedule: 'Schedule',
        scheduledFor: 'Scheduled for {date}.',
        cancelSchedule: 'Cancel schedule',
        dangerZone: 'Danger zone',
        delete: 'Delete campaign',
        created: 'Campaign created',
        testEmailMissing: 'Enter an email address to send the test to.',
        testSent: 'Test sent to {email}',
        confirmSend: 'Send "{subject}" to {n} confirmed subscriber now? This cannot be undone. | Send "{subject}" to {n} confirmed subscribers now? This cannot be undone.',
        queued: 'Campaign queued for sending',
        pickDate: 'Pick a date and time first.',
        scheduled: 'Campaign scheduled',
        unscheduled: 'Reverted to draft',
        confirmDelete: 'Delete "{subject}"?',
        deleted: 'Campaign deleted',
    },
    subscribers: {
        title: 'Subscribers',
        exportCsv: 'Export CSV',
        exportFailed: 'Export failed (HTTP {status})',
        searchPlaceholder: 'Search by email…',
        confirmedCount: '{n} confirmed subscriber | {n} confirmed subscribers',
        empty: 'No subscribers match these filters.',
        source: 'Source',
        confirmedAt: 'Confirmed',
        confirmRemove: 'Permanently remove {email}? This cannot be undone.',
        removed: 'Subscriber removed',
    },
    settings: {
        title: 'Newsletter settings',
        subscription: 'Subscription',
        doubleOptIn: 'Require email confirmation (double opt-in)',
        doubleOptInHelp: 'Recommended. New subscribers must click a confirmation link before they receive campaigns. This is the GDPR-aligned default and protects sender reputation. Turn off only if you capture consent another way.',
        confirmationSubject: 'Confirmation email subject',
        confirmationSubjectPlaceholder: 'Please confirm your newsletter subscription',
        confirmationSubjectHint: 'Leave blank to use the default.',
        sender: 'Sender',
        senderHelp: 'The From: address newsletter emails are sent under. Leave blank to use the website default. Sending fails if neither is set.',
        senderHelpWithDefault: 'The From: address newsletter emails are sent under. Leave blank to use the website default ({address}). Sending fails if neither is set.',
        fromEmail: 'From email',
        fromEmailPlaceholder: "news{'@'}example.com",
        fromName: 'From name',
        fromNamePlaceholder: 'Example Newsletter',
        effectiveSender: 'Effective sender: {address}',
        noSender: "No sender configured: campaigns can't be sent until you set one here or on the website.",
    },
};
